import Script from "next/script";
const JsonLdScripts = ({ jsonLdScripts }) => {
  let finalJsonLdScripts;
  if (!jsonLdScripts) return null;
  if (typeof jsonLdScripts === "object") {
    finalJsonLdScripts = [jsonLdScripts];
  }
  return finalJsonLdScripts?.map((jsonLd, index) => (
    <Script
      key={index}
      id="json-ld-script"
      type="application/ld+json"
      strategy="beforeInteractive"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      defer
    />
  ));
};

export default JsonLdScripts;
